import { MEDIA_PERMISSION_PROMPT_VISIBILITY_CHANGED } from './actionTypes';
/**
 * Opens {@link PageReloadDialog}.
 *
 * @param {any} _dummy1 - N/A for web.
 * @param {any} _dummy2 - N/A for web.
 * @param {any} _dummy3 - N/A for web.
 *
 * @returns {Function}
 */
export function openPageReloadDialog(_dummy1, _dummy2, _dummy3) {
    // Dummy
}
/**
 * Action to signal that the prompt for media permission is visible or not.
 * Preserved for 11sight compatibility.
 *
 * @param {boolean} isVisible - Whether the permission prompt is visible.
 * @param {string} browser - The browser name.
 * @returns {{
 *     type: MEDIA_PERMISSION_PROMPT_VISIBILITY_CHANGED,
 *     isVisible: boolean,
 *     browser: string
 * }}
 */
export function mediaPermissionPromptVisibilityChanged(isVisible, browser) {
    return {
        type: MEDIA_PERMISSION_PROMPT_VISIBILITY_CHANGED,
        isVisible,
        browser
    };
}
